<template>
  <section class="spaces py-8">
    <div class="container">
      <div class="_title" v-if="studio_title">
        <div class="label-div">
          <i class="mdi mdi-circle"></i>&nbsp;
          {{ label_div }}
        </div>
        <h1>{{ studio_title }}</h1>
        <span v-html="studio_description"></span>
      </div>
      <div v-else class="py-16">
        <v-skeleton-loader class="bg-transparent mx-auto" type="article" width="500"></v-skeleton-loader>
      </div>

      <div class="items" v-if="studios.length > 0">
        <div style="direction: rtl;" class="slider">
          <carousel v-bind="options">
            <slide class="slide-item" v-for="studio in studios" :key="studio.id">
              <div class="studio-item mx-3">
                <div class="img">
                  <img class="img-fluid main-img" :src="studio.main_image_url" alt="studio"/>
                  <div class="fav-icon" v-if="GetUserData">
                    <BSpinner v-if="studio.loading" style="color: #E61B42;"></BSpinner>
                    <a href="javascript:void(0);" @click.prevent="toggleFavorite(studio.id, studio.isFav)">
                      <i class="mdi" :class='studio.isFav ? "mdi-heart active" : "mdi-heart text-white"'></i>
                    </a>
                  </div>
                  <div class="rate" v-if="studio.totalRates > 0">
                    <span>{{ studio.totalRates }}</span>
                    <img class="img-fluid" src="/img/newMainPage/star.png" alt="star icon">
                  </div>
                </div>
                <div class="_info text-start">
                  <span class="Name text-start"> {{ studio.name }} </span>
                  <div class="d-flex align-items-center gap-5 categories-div">
                    <div class="d-flex align-items-center">
                      <img class="img-fluid" src="/img/newMainPage/location.svg" alt="location icon">
                      &nbsp;&nbsp;<span>{{ studio.city_name }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <img class="img-fluid" src="/img/newMainPage/category.svg" alt="category icon">
                      &nbsp;&nbsp;<span>{{ studio.category_name }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-row mt-4">
                    <router-link :to="{ name: 'studiosDetails', params: { id: (studio.slug ?? studio.id) } }">
                      <span class="d-inline-flex align-items-center show-more-link">
                        {{ $t("order-now") }}&nbsp;&nbsp;<i class="mdi mdi-arrow-top-left"></i>
                      </span>
                    </router-link>
                    <span class="price">
                      {{ studio.native_rent_price }}
                      <img v-if="lang === 'ar'" class="img-fluid" src="/img/newMainPage/sar.svg" alt="sar icon">
                      <div v-else>SAR</div>
                      /
                      {{ studio.native_rent_type }}
                    </span>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
      <div v-else class="row">
        <v-col cols="12" md="4" v-for="i in 3" :key="i">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </div>

      <div class="text-center text-sm-end mt-5" v-if="studios.length > 0">
        <router-link :to="redirect_link" class="btn btn-dark slider-btn">
          {{ $t("display-more") }}
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  props: ["studios", "studio_title", "studio_description", "redirect_link", "label_div"],
  data() {
    return {
      rating: 2,
      options: {
        loop: true,
        margin: 5,
        perPage: 1,
        center: false,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: true,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 5,
        rtl: true,
        perPageCustom: [
          [0, 1],
          [768, 2],
          [1332, 3],
        ],
      },
      lang: localStorage.getItem("lang") || "ar",
    };
  },
  computed: {
    ...mapGetters(["GetUserData"]),
  },
  methods: {
    toggleFavorite(studioId, isFav) {
      if (isFav) {
        this.removeFromFav(studioId);
      } else {
        this.addToFav(studioId);
      }
    },
    addToFav(studioId) {
      const index = this.studios.findIndex(p => p.id === studioId);
      if (index !== -1) {
        this.studios[index].loading = true;
        axios.post("add-studio-to-favorite?studio_id=" + studioId)
            .then((res) => {
              this.studios[index].loading = false;
              this.studios[index].isFav = true;
              this.TriggerNotify("success", res.data.message);
            })
            .catch((e) => {
              this.TriggerNotify("error", e.response.data.error);
              this.TriggerNotify("error", e.response.data.message);
              this.studios[index].loading = false;
            });
      }
    },
    removeFromFav(studioId) {
      const index = this.studios.findIndex(p => p.id === studioId);
      if (index !== -1) {
        this.studios[index].loading = true;
        axios.post("remove-studio-from-favorite?studio_id=" + studioId)
            .then((res) => {
              this.studios[index].loading = false;
              this.studios[index].isFav = false;
              this.TriggerNotify("success", res.data.message);
            })
            .catch((e) => {
              this.TriggerNotify("error", e.response.data.error);
              this.TriggerNotify("error", e.response.data.message);
              this.studios[index].loading = false;
            });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.spaces {
  margin: 0;

  ._title {
    h1 {
      color: #000;
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
      letter-spacing: -1.536px;
      margin-bottom: 24px;
    }

    span {
      color: #727272;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }

    @media (max-width: 768px) {
      h1 {
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
        margin-bottom: 8px;
      }
      span {
        font-size: 16px;
      }
    }
  }

  .studio-item {
    position: relative;
    background: #FFF;
    border-radius: 20px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.06);
    margin: 10px 0;

    @media(max-width: 1263px) {
      direction: rtl !important;
    }

    .img {
      position: relative;

      .main-img {
        width: 100%;
        height: 300px;
        position: relative;
        object-fit: cover;
        border-radius: 30px;
        padding: 24px;
        @media (max-width: 768px) {
          height: 200px;
          border-radius: 24px;
          padding: 16px;
        }
      }
    }

    .fav-icon {
      position: absolute;
      top: 22px;
      right: 32px;
      z-index: 9;

      i {
        font-size: 32px;

        &.active {
          color: #E61B42;
        }
      }
    }

    .rate {
      position: absolute;
      top: 32px;
      left: 32px;
      padding: 4px 8px;
      z-index: 9;
      border-radius: 4px;
      opacity: 0.6;
      background: #000;
      backdrop-filter: blur(30px);
      display: inline-flex;
      align-items: start;
      gap: 5px;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }

      span {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }

    ._info {
      padding: 0 20px 20px 20px;

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* number of lines to show */
        color: #8D8D8D;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
      }

      .Name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* number of lines to show */
        color: #000;
        font-size: 24px;
        line-height: 32px; /* 140% */
        font-style: normal;
        font-weight: 500;
        margin-bottom: 16px;
      }

      .price {
        color: #333;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        img {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }

      .show-more-link {
        border-radius: 8px;
        background: #F4F4F4;
        color: #000;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
        padding: 12px 32px;
      }

      .show-more-link:hover {
        background: #000;
        color: #fff;
        transition: 300ms ease-in-out;
      }

      @media (max-width: 768px) {
        padding: 0 16px 16px 16px;

        span {
          line-height: 12px; /* fallback */
          max-height: 24px; /* fallback */
          font-size: 10px;
        }

        .Name {
          line-height: 32px; /* fallback */
          max-height: 28px; /* fallback */
          font-size: 15px;
          font-weight: 700;
        }

        .price {
          font-size: 17px;
          font-weight: 600;
          line-height: normal;

          img {
            width: 18px;
            height: 18px;
          }
        }

        .show-more-link {
          border-radius: 8px;
          font-size: 15px;
          line-height: 26px;
          padding: 20px;
        }
      }

      .categories-div {
        img {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }

        span {
          color: #5B5B5B;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 26px;
        }

        @media (max-width: 768px) {
          img {
            width: 16px;
            height: 16px;
          }

          span {
            font-size: 14px;
            line-height: 26px;
          }
        }
      }
    }
  }
}

.slider-btn {
  border: 1px solid #1E1E1E;
  min-width: 230px;
  height: 52px;
  padding: 12px 0;
  border-radius: 8px;
  background: #1E1E1E;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  box-shadow: 0 1px 2px 0 rgba(13, 13, 18, 0.06);
}

@media (max-width: 599px) {
  .slider-btn {
    min-width: 90%;
  }
}
</style>
<style>
.spaces .VueCarousel-navigation-next {
  right: 75px !important;
}

[lang='en'] .spaces .VueCarousel-navigation-next {
  right: calc(100% - 72px) !important;
}

.spaces .VueCarousel-navigation-prev {
  left: calc(100% - 72px) !important;
}

[lang='en'] .spaces .VueCarousel-navigation-prev {
  left: 75px !important;
}
</style>
